import PropTypes from 'prop-types';
// @mui
import { Popover } from '@mui/material';

const MenuPopover = ({ children, sx, disableRestoreFocus = false, ...other }) => (
    <Popover
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        PaperProps={{
            sx: {
                p: 1,
                width: 200,
                overflow: 'inherit',
                ...sx,
            },
            role: 'menu',
        }}
        // Removed disableEnforceFocus to enable proper keyboard navigation
        // Use disableRestoreFocus only when explicitly needed
        disableRestoreFocus={disableRestoreFocus}
        {...other}
    >
        {children}
    </Popover>
);

MenuPopover.propTypes = {
    sx: PropTypes.object,
    children: PropTypes.node,
    disableRestoreFocus: PropTypes.bool,
};

export default MenuPopover;